import LoadingIndicator from 'gcs-common/components/LoadingIndicator/LoadingIndicator';
import {
  getAgentsTableAgentsLoading,
  getAgentsTableAgentsPaginationResult,
} from 'gcs-common/slices/administration/administrationUsers/administrationUsersSelectors';
import { agentSelected } from 'gcs-common/slices/administration/administrationUsers/administrationUsersSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import AgentTable from '../AgentTable/AgentTable';
import styles from './styles.module.scss';

const agentTableView = 'agentTableView';

const AgentOverview = () => {
  const agentsLoading = useSelector(getAgentsTableAgentsLoading);
  const agentsPagination = useSelector(getAgentsTableAgentsPaginationResult);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onAgentSelected = ({ id }) => {
    dispatch(agentSelected({ agentId: id }));
    navigate(`/administration/users/${id}`);
  };

  return (
    <>
      <div className={styles.headerRow}>
        <div className={styles.inputHeaderText}>
          Mitarbeiter (
          {/* biome-ignore lint/complexity/useOptionalChain: existing explicit guard keeps legacy null checks unchanged */}
          {agentsPagination && agentsPagination.total})
        </div>
        {agentsLoading && <LoadingIndicator padding="0" />}
      </div>
      <AgentTable onAgentSelected={onAgentSelected} view={agentTableView} agentsLoading={agentsLoading} />
    </>
  );
};

export default AgentOverview;
